import { LaunchOutlined as LaunchIcon } from '@mui/icons-material';
import { appUrl } from '@/utils/appUrl';

interface Failure {
  shippingNumber: string;
  reason: string;
}

interface BatchFailuresListProps {
  failures: Failure[];
}

const BatchFailuresList = ({ failures }: BatchFailuresListProps) => {
  return (
    <div className='flex flex-col gap-2 mt-2 max-h-[340px] overflow-y-auto pr-1'>
      {failures.map((failure) => (
        <div
          key={failure.shippingNumber}
          className='flex flex-col gap-1.5 p-3 rounded-lg bg-red-50 border border-red-100'
        >
          <a
            href={appUrl(`/business/shipping/${failure.shippingNumber}`)}
            target='_blank'
            rel='noopener noreferrer'
            className='font-black text-[#2196f3] hover:text-[#1976d2] hover:underline text-[14px] flex items-center gap-1 self-start transition-colors'
            title='Ver detalle del envío'
          >
            <LaunchIcon sx={{ fontSize: 15 }} />
            {failure.shippingNumber}
          </a>
          <span className='text-gray-600 text-[14px] leading-relaxed'>
            {failure.reason}
          </span>
        </div>
      ))}
    </div>
  );
};

export default BatchFailuresList;
